"use client";

import { AppHeader, AppFooter } from "@/widgets";

export function AppLayout({ children }: { children: React.ReactNode }) {
  return (
    <div>
      <AppHeader />

      {children}

      <AppFooter />
    </div>
  );
}
